import { render } from "./ResendDocument.vue?vue&type=template&id=ef7d11d6&scoped=true"
import script from "./ResendDocument.vue?vue&type=script&lang=js"
export * from "./ResendDocument.vue?vue&type=script&lang=js"

import "./ResendDocument.vue?vue&type=style&index=0&id=ef7d11d6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef7d11d6"]])

export default __exports__